const themePrefix = '--homepage-anim-theme-color-';

const themeMap = {
  bgFill: 'bg-fill',
  bgStroke: 'bg-stroke',
  ringStroke: 'ring-stroke',
};

const themes = {
  black: {
    bgFill: '#000',
    bgStroke: 'rgba(255, 255, 255, 0.25)',
    ringStroke: '#fff',
  },
  offWhite: {
    bgFill: '#ecede8',
    bgStroke: 'rgba(0, 0, 0, 0.2)',
    ringStroke: '#000',
  },
  white: {
    bgFill: '#fff',
    bgStroke: 'rgba(0, 0, 0, 0.1)',
    ringStroke: '#000',
  },
};

export const setTheme = theme => {
  const themeValues = themes[theme] || themes.offWhite;

  Object.entries(themeValues).forEach(([key, value]) => {
    const propertyName = themePrefix + themeMap[key];
    document.documentElement.style.setProperty(propertyName, value);
  });
};

export const getTheme = () =>
  Object.entries(themeMap).reduce((acc, [key, value]) => {
    const propertyName = themePrefix + value;
    acc[key] = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue(propertyName);
    return acc;
  }, {});
